import { Dropdown } from "primereact/dropdown";
import { PlatformIndicator } from "./PlatformIndicator";
import { useState } from "react";

export function StopIdPropertyDropdown({propertyName, initialVal, label, id, options, onDone}) {
    const [selectedOption, setSelectedOption] = useState(initialVal);
  
    const stopTemplate = (option) => {
      return (
        <div className="flex align-items-center">
          🚏 <div className="text-200 text-xs ml-1 mr-2">{option.stop_id}</div> <div className="mr-2">{option.stop_name}</div> <PlatformIndicator platformCode={option.platform_code}/>      
        </div>
      )
    }
  
    const selectedStopTemplate = (option, props) => {
      if (option) {
        return (
          <div className="flex align-items-center">
            <div className="text-200 text-xs ml-1 mr-2">{option.stop_id}</div> <div className="mr-2">{option.stop_name}</div> <PlatformIndicator platformCode={option.platform_code}/>      
          </div>
        )      
      }
  
      return <span>{props.placeholder}</span>
    }  
  
    return (
      <>
        <label htmlFor={id + '-' + propertyName}>{label}</label>        
        <Dropdown filter 
                showClear
                value={selectedOption}
                inputId={id + '-' + propertyName}  
                onChange={(e) => {
                    setSelectedOption(e.value);
                    onDone(propertyName,e.value);
                  }
                } 
                options={options}
                itemTemplate={stopTemplate} 
                valueTemplate={selectedStopTemplate}
                optionLabel="stop_name"
                optionValue="stop_id"
                filterBy="stop_name,stop_id,stop_code,platform_code"
                placeholder="(proszę wybrać)" 
                virtualScrollerOptions={{
                    itemSize: 38,
                }}
                className="w-full" 
        />
      </>    
    )
  
  }